import moment from 'moment-timezone';

import { constantCreator } from '~/utils/constantsCreator';
import api from '~/utils/api';
import { sortTimeOfDay } from '~/utils/explore/filter';

const constant = constantCreator('explore');
const OPEN_FILTER = constant('OPEN_FILTER');
const CLOSE_FILTER = constant('CLOSE_FILTER');
const CLEAR_FILTER = constant('CLEAR_FILTER');
const TOGGLE_ACTIVITY = constant('TOGGLE_ACTIVITY');
const SELECT_DATE = constant('SELECT_DATE');
const SELECT_CITY = constant('SELECT_CITY');
const SELECT_TIME = constant('SELECT_TIME');
const SELECT_GUESTS = constant('SELECT_GUESTS');
const CHANGE_SORTING_BY = constant('CHANGE_SORTING_BY');
const LOAD_TRIPS = constant('LOAD_TRIPS', true);
const PROGRESS_PAGINATION = constant('PROGRESS_PAGINATION');
const RESET_PAGINATION = constant('RESET_PAGINATION');

const initialState = {
  currentFilterPage: '',
  city: '',
  date: moment().isAfter(moment().hour(21).minute(0))
    ? moment().add(1, 'day').startOf('day').toISOString() // prettier-ignore
    : moment().startOf('day').toISOString(), // prettier-ignore
  sortingBy: 'booking',
  trips: [],
  activities: [],
  selectedActivities: [],
  isLoadingTrips: true,
  skip: 0,
  limit: 12,
  isLast: false,
  time: ['morning', 'afternoon', 'evening'],
  guests: 2,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_FILTER: {
      return {
        ...state,
        currentFilterPage: action.name
      };
    }
    case CLOSE_FILTER: {
      return {
        ...state,
        currentFilterPage: ''
      };
    }
    case CLEAR_FILTER: {
      return {
        ...state,
        date: initialState.date,
        sortingBy: initialState.sortingBy,
        activities: initialState.activities,
        selectedActivities: initialState.selectedActivities,
        time: initialState.time,
        skip: 0,
        limit: initialState.limit
      };
    }
    case SELECT_DATE:
      return {
        ...state,
        date: moment(action.date).toISOString(),
        skip: 0,
        limit: initialState.limit
      };
    case SELECT_TIME:
      return {
        ...state,
        time: sortTimeOfDay(action.time),
        skip: 0,
        limit: initialState.limit
      };
    case CHANGE_SORTING_BY: {
      return {
        ...state,
        sortingBy: action.sortingBy,
        skip: 0,
        limit: initialState.limit
      };
    }
    case SELECT_CITY:
      return {
        ...state,
        city: action.city,
        date: initialState.date,
        sortingBy: initialState.sortingBy,
        activities: initialState.activities,
        selectedActivities: initialState.selectedActivities,
        time: initialState.time,
        skip: 0,
        limit: initialState.limit
      };
    case SELECT_GUESTS:
      return {
        ...state,
        guests: action.guests,
        skip: 0,
        limit: initialState.limit
      };
    case LOAD_TRIPS.PENDING:
    case LOAD_TRIPS.REJECTED:
      return {
        ...state,
        isLoadingTrips: !action.append
      };
    case LOAD_TRIPS.RESOLVED: {
      return {
        ...state,
        isLoadingTrips: false,
        trips: action.append ? [...state.trips, ...action.data.trips] : action.data.trips,
        activities: action.data.activities,
        isLast: action.data.trips.length < initialState.limit
      };
    }
    case PROGRESS_PAGINATION:
      return {
        ...state,
        skip: state.skip + initialState.limit,
        limit: state.limit
      };
    case RESET_PAGINATION:
      return {
        ...state,
        skip: 0,
        limit: initialState.limit
      };
    case TOGGLE_ACTIVITY: {
      const index = state.selectedActivities.indexOf(action.activity);
      if (index >= 0) {
        return {
          ...state,
          selectedActivities: [
            ...state.selectedActivities.slice(0, index),
            ...state.selectedActivities.slice(index + 1)
          ],
          skip: 0,
          limit: initialState.limit
        };
      }
      return {
        ...state,
        selectedActivities: [...state.selectedActivities, action.activity],
        skip: 0,
        limit: initialState.limit
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const actions = {
  openFilter: name => ({
    type: OPEN_FILTER,
    name,
  }),
  closeFilter: name => ({
    type: CLOSE_FILTER,
    name
  }),
  clearFilter: () => ({
    type: CLEAR_FILTER,
  }),
  selectDate: date => ({
    type: SELECT_DATE,
    date
  }),
  selectCity: city => ({
    type: SELECT_CITY,
    city
  }),
  selectTime: time => ({
    type: SELECT_TIME,
    time
  }),
  selectGuests: guests => ({
    type: SELECT_GUESTS,
    guests
  }),
  changeSortingBy: sortingBy => ({
    type: CHANGE_SORTING_BY,
    sortingBy
  }),
  loadTrips: filterState => ({
    type: LOAD_TRIPS,
    promise: api.get(
      `/explore?city=${filterState.city}&sortBy=${filterState.sortingBy}&quantity=${filterState.guests}&date=${
        moment(filterState.date).format('DD-MM-YYYY')
      }&skip=${filterState.skip}&limit=${filterState.limit}${
        filterState.time && filterState.time.length > 0 ? `&start_time=${filterState.time}` : ''
      }${filterState.activities && filterState.activities.length > 0 ? `&activity=${filterState.activities}` : ''}`
    ),
    append: filterState.skip > 0
  }),
  progressPagination: () => ({
    type: PROGRESS_PAGINATION
  }),
  resetPagination: () => ({
    type: RESET_PAGINATION
  }),
  toggleActivity: activity => ({
    type: TOGGLE_ACTIVITY,
    activity
  })
};
